import { mmFetchWithResponse } from './mmFetchWithResponse';

const userApi = {
    getUserAlerts: async () => {
        const url = 'api/alerts/v1/history';
        return mmFetchWithResponse(url);
    },
    getUserAlertSubscriptions: async (facilitiesID) => {
        const url = `api/alerts/v1/subs/${facilitiesID}`;
        return mmFetchWithResponse(url);
    },
    getUsersRoles: async () => {
        const url = 'api/admin/v1/check/roles';
        return mmFetchWithResponse(url);
    },
    subscribeToAlert: async (alertTypeID) => {
        const url = `api/alerts/v1/${alertTypeID}/subscribe`;
        return mmFetchWithResponse(url, { method: 'PUT' });
    },
    unsubscribeFromAlert: async (alertTypeID) => {
        const url = `api/alerts/v1/${alertTypeID}/unsubscribe`;
        return mmFetchWithResponse(url, { method: 'PUT' });
    },
    updateLanguage: async (userID, language) => {
        const url = `api/admin/v2/jalacounts/user/update`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({
                id: userID,
                language,
            }),
        });
    },
    updateFacility: async (userID, facilityID) => {
        const url = `api/admin/v2/jalacounts/user/update`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({
                id: userID,
                facilityID,
            }),
        });
    },
};

export { userApi };
